import React, { useState } from 'react';
import axios from 'axios';
import './LandingPage.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function LandingPage({ onLogin, isPublicOnly = false, onLoginFailed, remainingAttempts = 5 }) {
  const [activeSection, setActiveSection] = useState('tracking');

  const [noResi, setNoResi] = useState('');
  const [trackingResult, setTrackingResult] = useState(null);
  const [trackingError, setTrackingError] = useState('');
  const [trackingLoading, setTrackingLoading] = useState(false);

  const [formData, setFormData] = useState({
    no_telp: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const showSection = (section) => {
    setActiveSection(section);
    setTrackingError('');
    setTrackingResult(null);
    setError('');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  const handleTrackingSubmit = async (e) => {
    e.preventDefault();
    setTrackingError('');
    setTrackingResult(null);
    setTrackingLoading(true);

    try {
      const response = await axios.get(`${API_URL}/api/public/tracking/${noResi.trim()}`);
      if (response.data.success && response.data.data) {
        setTrackingResult(response.data.data);
      } else {
        setTrackingError('Nomor resi tidak ditemukan. Pastikan nomor resi Anda benar.');
      }
    } catch (err) {
      console.error('Tracking error:', err);
      if (err.response?.status === 404) {
        setTrackingError('Nomor resi tidak ditemukan. Pastikan nomor resi Anda benar.');
      } else {
        setTrackingError('Terjadi kesalahan saat mencari data. Silakan coba lagi.');
      }
    } finally {
      setTrackingLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/api/login`, formData);
      onLogin(response.data.token, response.data.user);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Login gagal. Silakan coba lagi.';
      setError(errorMsg);
      if (onLoginFailed) onLoginFailed();
    } finally {
      setLoading(false);
    }
  };

  const getStatusInfo = (status) => {
    const statusConfig = {
      'diterima': { 
        text: 'Diterima', 
        className: 'status-delivered',
        icon: 'bi-check-circle-fill'
      },
      'dikirim': { 
        text: 'Dikirim', 
        className: 'status-intransit',
        icon: 'bi-truck'
      },
      'dalamproses': { 
        text: 'Dalam Proses', 
        className: 'status-processing',
        icon: 'bi-box-seam'
      }
    };
    return statusConfig[status] || { text: status, className: 'status-default', icon: 'bi-circle' };
  };

const TrackingResultDisplay = ({ result }) => {
    const mainStatus = getStatusInfo(result.status);
    
    return (
      <div className="result-section show">
        <div className="tracking-details">
          <div className="tracking-header">
            <div>
              <div className="info-label">Nomor Surat Jalan</div>
              <div className="tracking-number">{result.no_resi}</div>
            </div>
            <div className={`tracking-status ${mainStatus.className}`}>
              <i className={`bi ${mainStatus.icon} me-1`}></i>
              {mainStatus.text}
            </div>
          </div>

          <div className="info-grid">
            <div className="info-item">
              <div className="info-label">Pengirim</div>
              <div className="info-value">{result.nama_pengirim}</div>
            </div>
            <div className="info-item">
              <div className="info-label">Penerima</div>
              <div className="info-value">{result.nama_penerima}</div>
            </div>
            <div className="info-item">
              <div className="info-label">Lokasi Muat</div>
              <div className="info-value">{result.alamat_asal}</div>
            </div>
            <div className="info-item">
              <div className="info-label">Lokasi Bongkar</div>
              <div className="info-value">{result.alamat_tujuan}</div>
            </div>
            <div className="info-item">
              <div className="info-label">Jenis Muatan</div>
              <div className="info-value">{result.nama_barang}</div>
            </div>
            <div className="info-item">
              <div className="info-label">Berat Muatan</div>
              <div className="info-value">{result.berat} kg ({result.jumlah_barang} item)</div>
            </div>
          </div>

          {result.statusHistory?.length > 0 && (
  <div className="timeline">
    <div className="timeline-title">Riwayat Perjalanan Truk</div>
    <div id="timelineContainer">
      {result.statusHistory.map((history, index) => {
                  const historyStatus = getStatusInfo(history.status);
                  return (
                    <div key={history.id} className="timeline-item">
                      <div className="timeline-dot"></div>
                      <div className="timeline-content">
                        <div className="timeline-date">
                          {new Date(history.tanggal).toLocaleDateString('id-ID', { 
                            day: 'numeric',
                            month: 'long', 
                            year: 'numeric'
                          })} pukul {new Date(history.tanggal).toLocaleTimeString('id-ID', { 
                            hour: '2-digit',
                            minute: '2-digit'
                          })} WIB
                        </div>
                        <div className="timeline-text">
                          <i className={`bi ${historyStatus.icon} me-1`}></i>
                          {historyStatus.text}
                        </div>
                        <div className="timeline-location">{history.lokasi}</div>
                        {history.dokumentasi && (
                          <div className="timeline-photo-wrapper">
                            <img 
                              src={`${API_URL}${history.dokumentasi}`}
                              alt="Dokumentasi status"
                              className="timeline-photo"
                              onClick={() => window.open(`${API_URL}${history.dokumentasi}`, '_blank')}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  
  return (
    <>
      <div className="decorative-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="header">
        <div className="header-content">
          <div className="logo">
            <div className="truck-icon">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="26" 
                height="26" 
                fill="white" 
                viewBox="0 0 16 16"
                style={{ display: 'block' }}
              >
                <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5zm1.294 7.456A2 2 0 0 1 4.732 11h5.536a2 2 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456M12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
              </svg>
            </div>
            <span className="logo-text">ZHAFRAN TRANSPORT</span>
          </div>
          <div className="header-info">
            <div>
              <i className="bi bi-telephone-fill me-1"></i>
               0813-3219-1023
            </div>
          </div>
        </div>
      </div>

{isPublicOnly && (
        <nav>
          <div className="nav-content">
            <a 
              href="#tracking"
              className={activeSection === 'tracking' ? 'nav-link active' : 'nav-link'} 
              onClick={(e) => {
                e.preventDefault();
                showSection('tracking');
              }}
            >
              Lacak Pengiriman
            </a>
            <a 
              href="#kontak"
              className={activeSection === 'kontak' ? 'nav-link active' : 'nav-link'} 
              onClick={(e) => {
                e.preventDefault();
                showSection('kontak');
              }}
            >
              Hubungi Kami
            </a>
          </div>
        </nav>
      )}

      <div className="container">
        <div className={`section ${activeSection === 'tracking' ? 'active' : ''}`} id="tracking">
          <div className="main-section">
            {isPublicOnly ? (
              <>
                <h1>
                  <i className="bi bi-truck me-2"></i>
                  Lacak Pengiriman Truk Anda
                </h1>
                <p className="subtitle">
                  Pantau status pengiriman muatan truk Anda secara real-time. Masukkan nomor resi untuk melihat posisi barang Anda.
                </p>

                <form onSubmit={handleTrackingSubmit} className="tracking-form">
                  <div className="form-group">
                    <label htmlFor="resi">Masukkan Nomor Resi</label>
                    <input
                      type="text"
                      id="resi"
                      value={noResi}
                      onChange={(e) => {
                        setNoResi(e.target.value);
                        if (trackingError) setTrackingError('');
                        if (trackingResult) setTrackingResult(null);
                      }}
                      placeholder="Contoh: ZT12345678"
                      required
                      disabled={trackingLoading}
                    />
                  </div>
                  <button type="submit" className="btn-track" disabled={trackingLoading}>
                    {trackingLoading ? (
                      <>
                        <i className="bi bi-hourglass-split me-2"></i>
                        Mencari...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-search me-2"></i>
                        Lacak Sekarang
                      </>
                    )}
                  </button>
                </form>

                {trackingError && (
                  <div className="error-message-box">
                    <i className="bi bi-x-circle me-2"></i>
                    {trackingError}
                  </div>
                )}

                {trackingResult && <TrackingResultDisplay result={trackingResult} />}
              </>
            ) : (
                     <>
                <h1>
                  <i className="bi bi-shield-lock me-2"></i>
                  Login Admin
                </h1>
                <p className="subtitle">
                  Masukkan no telp dan password untuk mengakses sistem manajemen
                </p>

                <form onSubmit={handleLoginSubmit} className="tracking-form">
                  {error && (
                    <div className="error-message-box">
                      <i className="bi bi-x-circle me-2"></i>
                      {error}
                    </div>
                  )}

                  {remainingAttempts < 5 && (
                    <div className="info-message-box" style={{
                      background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(217, 119, 6, 0.1))',
                      border: '2px solid rgba(245, 158, 11, 0.3)',
                      color: '#d97706',
                      marginBottom: '20px'
                    }}>
                      <i className="bi bi-exclamation-triangle me-2"></i>
                      Sisa percobaan: {remainingAttempts}/5
                    </div>
                  )}
                  
                  <div className="form-group">
                    <label htmlFor="no_telp">No Telepon</label>
                    <input
                      type="text"
                      id="no_telp"
                      name="no_telp"
                      value={formData.no_telp}
                      onChange={handleChange}
                      placeholder="Masukkan no telepon"
                      required
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Masukkan password"
                      required
                      disabled={loading}
                    />
                  </div>

                  <button type="submit" className="btn-track" disabled={loading}>
                    {loading ? (
                      <>
                        <i className="bi bi-hourglass-split me-2"></i>
                        Loading...
                      </>
                    ) : (
                      'Login'
                    )}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
        <div className={`section ${activeSection === 'kontak' ? 'active' : ''}`} id="kontak">
          <div className="main-section">
            <h1>
              <i className="bi bi-chat-dots me-2"></i>
              Hubungi Kami
            </h1>
            <p className="subtitle">
              Butuh pengiriman material pabrik, atau muatan berat lainnya? Tim kami siap melayani kebutuhan logistik industri Anda dengan armada truk yang handal.
            </p>

            <div className="contact-info-container">
              <div className="contact-info">
                <h2>Informasi Kontak</h2>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="bi bi-geo-alt-fill"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Alamat Pool Truk</h4>
                    <p>Jl. Persatuan 1<br/>Wonokerto Lor, Wonoplintahan RT.4/RW.1<br/>Kecamatan Prambon, Kabupaten Sidoarjo, Jawa Timur 61264</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="bi bi-telephone-fill"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Telepon & WhatsApp</h4>
                    <p>Kantor: 0813-3219-1023<br/>(24 Jam untuk Kebutuhan Mendesak)</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="bi bi-clock-fill"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Jam Operasional</h4>
                    <p>Senin - Jumat: 08.00 - 17.00 WIB<br/>Sabtu: 08.00 - 13.00 WIB<br/>Minggu & Libur: Tutup<br/><strong>Operasional Truk: 24/7</strong></p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="bi bi-truck"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Layanan Kami</h4>
                    <p>• Material Pabrik & Industri<br/>• Muatan Berat (Heavy Cargo)<br/>• Antar Pulau Jawa & Luar Pulau</p>
                  </div>
                </div>

                <div className="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3013.429625999046!2d112.57155727500152!3d-7.455048792556214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zN8KwMjcnMTguMiJTIDExMsKwMzQnMjYuOSJF!5e1!3m2!1sid!2sid!4v1764544611455!5m2!1sid!2sid"
                    width="100%"
                    height="350"
                    style={{ border: 0, borderRadius: '15px' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Lokasi Pool Truk Zhafran Transport"
                  ></iframe>
                  <button
                    onClick={() => window.open('https://maps.app.goo.gl/rsk1ayjistfYjbcf8?g_st=iw', '_blank')}
                    className="map-link-button"
                  >
                    <i className="bi bi-map me-2"></i>
                    Buka di Google Maps
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <div className="footer-content">
          <h3>ZHAFRAN TRANSPORT</h3>
          <p>Jasa Pengiriman Truk Muatan Berat & Material Industri Maupun Logistik </p>
          <p style={{marginTop: '10px', fontSize: '14px'}}>Melayani Pengiriman Antar Kota Se-Jawa & Luar Pulau</p>
          
          <div className="footer-links">
            <button className="footer-link-btn" onClick={() => showSection('tracking')}>
              Lacak Pengiriman
            </button>
            <button className="footer-link-btn" onClick={() => showSection('kontak')}>
              Hubungi Kami
            </button>
          </div>

          <div className="footer-bottom">
            <p>&copy; Niko Dwi Novana - Prodi Informatika - Universitas Muhammadiyah Sidoarjo</p>
            <p style={{marginTop: '8px'}}>Pool Truk: Jl. Persatuan 1 Wonokerto Lor, Wonoplintahan RT.4/RW.1 Kecamatan Prambon, Kabupaten Sidoarjo, Jawa Timur 61264</p>
            <p style={{marginTop: '5px', fontSize: '13px'}}>Siap Melayani 24/7 - Hubungi Kami untuk Penawaran Terbaik</p>
          </div>
        </div>
      </footer>
      {isPublicOnly && (
        <a 
          href="https://wa.me/6281332191023?text=Halo%20Zhafran%20Transport,%20saya%20ingin%20bertanya%20tentang%20layanan%20pengiriman%20truk." 
          target="_blank" 
          rel="noopener noreferrer"
          className="whatsapp-float"
          aria-label="Chat WhatsApp"
        >
          <i className="bi bi-whatsapp"></i>
        </a>
      )}
    </>
  );
}

export default LandingPage;